import React from 'react'
import {useParams} from 'react-router-dom'
import {ReseauClientListPage} from '../../../../ReseauClient/ReseauClientListPage'

const ClientReseaux = () => {
  let {clientId} = useParams()
  return <ReseauClientListPage displayClientInfo={true} clientId={clientId} />
}

export {ClientReseaux}
